
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util'
	import AbpBase from '@/lib/abpbase'
	import PageRequest from '@/store/entities/page-request'
	class PageNewsRequest extends PageRequest {
		tagType:number;
		tagId:number;
		Status:string
	}
	@Component({
		components: {

		}
	})
	export default class NewsDetail extends AbpBase {
			newsList: Array < any >= new Array < any > ();
			totalCount: Number = 0;
			currentPage: Number = 1;
			pageSize: Number = 0;
			pagerequest: PageNewsRequest = new PageNewsRequest();
	
			pageChange(page: number) {
				this.currentPage = page;
				//this.$store.commit('news/setCurrentPage', page);
				this.getNewsList();
			}
			pagesizeChange(pagesize: number) {
				this.pageSize = pagesize;
				this.currentPage = 1;
				this.getNewsList();
			}
			get getPageSize() {
				return this.pageSize as any;
			}
			
			get getCurrentPage() {
				return this.currentPage as any;
			}
			getNewsList() {
				let that = this;
				//let pageindex = (that.currentPage * 1 - 1) as any;
				this.pagerequest.maxResultCount = this.pageSize as any;
				this.pagerequest.skipCount = (this.getCurrentPage - 1) * this.getPageSize;
				this.pagerequest.tagType = 4;
				this.pagerequest.Status="OP";
				// this.pagerequest.tagId = 4;
				// let pageNoticeRequest = {
				// 	SkipCount: pageindex*that.pageSize,
				// 	MaxResultCount: that.pageSize,
				// 	TagType: 4,
				// 	TagId: 7,
				// }
				this.$store.dispatch({
					type: 'app/getNewsList',
					data: this.pagerequest
				}).then(res => {
					that.totalCount = res.totalCount;
					//that.noticeList = res.items;
					for(var j = 0; j <  res.items.length; j++){
						res.items[j].imagebox=false;
						if (res.items[j].coverImg != '' && res.items[j].coverImg!=null) {
							res.items[j].imagebox = true;
						}
						 res.items[j].time=Util.formatDate(new Date( res.items[j].creationTime),'yyyy-MM-dd hh:mm:ss');
					}
					
					that.newsList = res.items;
				})
			}
			showNewsDetail(newid) {
				window.open('#/newsdetail?newid='+newid);
				// this.$router.push({
				// 	path: '/newsdetail',
				// 	query: {
				// 		newid: newid
				// 	}
				// })
			}
			created() {
				this.currentPage = 1;
				this.pageSize = 10;
				this.getNewsList();
			}
		};
	
